import * as React from "react"

const SvgOpenEmailFile = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 18.714q-.824 0-1.413-.587A1.93 1.93 0 0 1 1 16.714v-12q0-.086.006-.168L1 4.539h.007q.057-.714.58-1.237A1.93 1.93 0 0 1 3 2.714h16q.824 0 1.413.588.523.524.58 1.237H21l-.006.007q.006.082.006.168l-.006 4.004A.997.997 0 0 1 19 8.717V6.589l-6.975 4.175A2 2 0 0 1 11 11.04q-.55 0-1.025-.275L3 6.59v10.125h9a1 1 0 1 1 0 2H3Zm.745-14h14.51L11 9.04z"
      clipRule="evenodd"
    />
    <path d="M16.175 21.54Q17.35 22.714 19 22.714c1.65 0 2.042-.391 2.825-1.175Q23 20.364 23 18.714v-3a.97.97 0 0 0-.288-.712.97.97 0 0 0-.712-.288.97.97 0 0 0-.712.288.97.97 0 0 0-.288.712v3a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587q-.824 0-1.413-.587A1.93 1.93 0 0 1 17 18.714v-4.5q0-.2.15-.35a.48.48 0 0 1 .7 0q.15.15.15.35v3.5q0 .425.288.713.287.288.712.287c.425-.001.52-.095.712-.287a.97.97 0 0 0 .288-.713v-3.5q0-1.05-.725-1.775t-1.775-.725c-1.05 0-1.292.242-1.775.725A2.42 2.42 0 0 0 15 14.214v4.5q0 1.65 1.175 2.825Z" />
  </svg>
)
export default SvgOpenEmailFile
